import { usePathname } from 'next/navigation'

export function Reason() {
  const pathname = usePathname()

  return (
    <section>
      <div className="mx-auto px-6 xl:px-0 pt-10 pb-10 text-center lg:pt-40 lg:pb-20 lg:max-w-[1200px]">
        <h2 className="text-lg font-bold text-textblack text-center lg:text-4xl font-feature-settings">
          LAWGUEが選ばれる理由
        </h2>

        <div className="mt-6 flex flex-wrap justify-between gap-4 lg:gap-10 lg:mt-14">
          {pathname === '/contract/' && (
            <>
              <div className="w-full lg:w-[280px]">
                <div className="flex flex-col-reverse items-center">
                  <div>
                    <div className="flex flex-col-reverse items-center">
                      <h3 className="text-xl font-bold text-textblack text-center lg:text-2xl font-feature-settings">
                        最大50%レビュー時間を削減
                      </h3>
                      <p className="text-4xl text-primary text-center font-robot font-bold lg:text-5xl">
                        01
                      </p>
                    </div>
                    <p className="mt-3 text-sm text-textblack text-center lg:text-base">
                      検索・チェックにおける非効率な作業をなくすことで大幅に効率化できます
                    </p>
                  </div>
                  <figure>
                    <img
                      decoding="async"
                      src="/images/solution/img_contract_solution01.svg"
                      alt=""
                      className="w-auto h-full"
                    />
                  </figure>
                </div>
              </div>

              <div className="w-full lg:w-[280px]">
                <div className="flex flex-col-reverse items-center">
                  <div>
                    <div className="flex flex-col-reverse items-center">
                      <h3 className="text-xl font-bold text-textblack text-center lg:text-2xl font-feature-settings">
                        見える化された
                        <br />
                        AIレビュー
                      </h3>
                      <p className="text-4xl text-primary text-center font-robot font-bold lg:text-5xl">
                        02
                      </p>
                    </div>
                    <p className="mt-3 text-sm text-textblack text-center lg:text-base">
                      AIによる判断ではなく、「AI」が見つけて「あなた」が判断していきます
                    </p>
                  </div>
                  <figure>
                    <img
                      decoding="async"
                      src="/images/solution/img_contract_solution02.svg"
                      alt=""
                      className="w-auto h-full"
                    />
                  </figure>
                </div>
              </div>

              <div className="w-full lg:w-[280px]">
                <div className="flex flex-col-reverse items-center">
                  <div>
                    <div className="flex flex-col-reverse items-center">
                      <h3 className="text-xl font-bold text-textblack text-center lg:text-2xl font-feature-settings">
                        どんな契約書にも
                        <br />
                        対応
                      </h3>
                      <p className="text-4xl text-primary text-center font-robot font-bold lg:text-5xl">
                        03
                      </p>
                    </div>
                    <p className="mt-3 text-sm text-textblack text-center lg:text-base">
                      様々な業界で、様々な契約書の導入・使用実績があります
                    </p>
                  </div>
                  <figure>
                    <img
                      decoding="async"
                      src="/images/solution/img_contract_solution03.svg"
                      alt=""
                      className="w-auto h-full"
                    />
                  </figure>
                </div>
              </div>
            </>
          )}

          {pathname === '/law/' && (
            <>
              <div className="w-full lg:w-[280px]">
                <div className="flex flex-col-reverse items-center">
                  <div>
                    <div className="flex flex-col-reverse items-center">
                      <h3 className="text-xl font-bold text-textblack text-center lg:text-2xl font-feature-settings">
                        効率的なクラウド上
                        <br />
                        での管理
                      </h3>
                      <p className="text-4xl text-primary text-center font-robot font-bold lg:text-5xl">
                        01
                      </p>
                    </div>
                    <p className="mt-3 text-sm text-textblack text-center lg:text-base">
                      クラウド上にデータベース化することで一元管理できます
                    </p>
                  </div>
                  <figure>
                    <img
                      decoding="async"
                      src="/images/solution/img_contract_solution10.svg"
                      alt=""
                    />
                  </figure>
                </div>
              </div>
              <div className="w-full lg:w-[280px]">
                <div className="flex flex-col-reverse items-center">
                  <div>
                    <div className="flex flex-col-reverse items-center">
                      <h3 className="text-xl font-bold text-textblack text-center lg:text-2xl font-feature-settings">
                        AIのサポートによる
                        <br />
                        圧倒的な効率化
                      </h3>
                      <p className="text-4xl text-primary text-center font-robot font-bold lg:text-5xl">
                        02
                      </p>
                    </div>
                    <p className="mt-3 text-sm text-textblack text-center lg:text-base">
                      煩わしい作業はAIで自動化して改訂作業に集中できます
                    </p>
                  </div>
                  <figure>
                    <img
                      decoding="async"
                      src="/images/solution/img_contract_solution05.svg"
                      alt=""
                    />
                  </figure>
                </div>
              </div>
              <div className="w-full lg:w-[280px]">
                <div className="flex flex-col-reverse items-center">
                  <div>
                    <div className="flex flex-col-reverse items-center">
                      <h3 className="text-xl font-bold text-textblack text-center lg:text-2xl font-feature-settings">
                        信頼・最新の情報との
                        <br />
                        連携
                      </h3>
                      <p className="text-4xl text-primary text-center font-robot font-bold lg:text-5xl">
                        03
                      </p>
                    </div>
                    <p className="mt-3 text-sm text-textblack text-center lg:text-base">
                      信頼・最新の情報を提供する「D1-Law.com」と連携しています
                    </p>
                  </div>
                  <figure>
                    <img
                      decoding="async"
                      src="/images/solution/img_contract_solution12.svg"
                      alt=""
                    />
                  </figure>
                </div>
              </div>
            </>
          )}

          {pathname === '/regulation/' && (
            <>
              <div className="w-full lg:w-[280px]">
                <div className="flex flex-col-reverse items-center">
                  <div>
                    <div className="flex flex-col-reverse items-center">
                      <h3 className="text-xl font-bold text-textblack text-center lg:text-2xl font-feature-settings">
                        豊富な
                        <br />
                        規程雛形集
                      </h3>
                      <p className="text-4xl text-primary text-center font-robot font-bold lg:text-5xl">
                        01
                      </p>
                    </div>
                    <p className="mt-3 text-sm text-textblack text-center lg:text-base">
                      法令出版社が提供する規程雛形を多数搭載しています
                      <br />
                      <span className="text-xs text-left block mt-2">
                        *オプション機能
                      </span>
                    </p>
                  </div>
                  <figure>
                    <img
                      decoding="async"
                      src="/images/solution/img_contract_solution04.svg"
                      alt=""
                      className="w-auto h-full"
                    />
                  </figure>
                </div>
              </div>

              <div className="w-full lg:w-[280px]">
                <div className="flex flex-col-reverse items-center">
                  <div>
                    <div className="flex flex-col-reverse items-center">
                      <h3 className="text-xl font-bold text-textblack text-center lg:text-2xl font-feature-settings">
                        AIのサポートによる圧倒的な効率化
                      </h3>
                      <p className="text-4xl text-primary text-center font-robot font-bold lg:text-5xl">
                        02
                      </p>
                    </div>
                    <p className="mt-3 text-sm text-textblack text-center lg:text-base">
                      煩わしい作業はAIで自動化して改訂作業に集中できます
                    </p>
                  </div>
                  <figure>
                    <img
                      decoding="async"
                      src="/images/solution/img_contract_solution05.svg"
                      alt=""
                      className="w-auto h-full"
                    />
                  </figure>
                </div>
              </div>

              <div className="w-full lg:w-[280px]">
                <div className="flex flex-col-reverse items-center">
                  <div>
                    <div className="flex flex-col-reverse items-center">
                      <h3 className="text-xl font-bold text-textblack text-center lg:text-2xl font-feature-settings">
                        社会保険労務士事務所での導入実績
                      </h3>
                      <p className="text-4xl text-primary text-center font-robot font-bold lg:text-5xl">
                        03
                      </p>
                    </div>
                    <p className="mt-3 text-sm text-textblack text-center lg:text-base">
                      規程のスペシャリストである社会保険労務士も活用しています
                    </p>
                  </div>
                  <figure>
                    <img
                      decoding="async"
                      src="/images/solution/img_contract_solution06.svg"
                      alt=""
                      className="w-auto h-full"
                    />
                  </figure>
                </div>
              </div>
            </>
          )}

          {pathname === '/translation/' && (
            <>
              <div className="w-full lg:w-[280px]">
                <div className="flex flex-col-reverse items-center">
                  <div>
                    <div className="flex flex-col-reverse items-center">
                      <h3 className="text-xl font-bold text-textblack text-center lg:text-2xl font-feature-settings">
                        精度の高い
                        <br />
                        AI翻訳
                      </h3>

                      <p className="text-4xl text-primary text-center font-robot font-bold lg:text-5xl">
                        01
                      </p>
                    </div>
                    <p className="mt-3 text-sm text-textblack text-center lg:text-base">
                      契約書に特化した翻訳エンジンとの連携で高い翻訳精度を誇ります
                      <br />
                      <span className="text-xs text-left block mt-2">
                        *オプション機能（T-4OOとの連携）
                      </span>
                    </p>
                  </div>
                  <figure>
                    <img
                      decoding="async"
                      src="/images/solution/img_contract_solution07.svg"
                      alt=""
                      className="w-auto h-full"
                    />
                  </figure>
                </div>
              </div>

              <div className="w-full lg:w-[280px]">
                <div className="flex flex-col-reverse items-center">
                  <div>
                    <div className="flex flex-col-reverse items-center">
                      <h3 className="text-xl font-bold text-textblack text-center lg:text-2xl font-feature-settings">
                        ワン
                        <br />
                        プラットフォーム
                      </h3>

                      <p className="text-4xl text-primary text-center font-robot font-bold lg:text-5xl">
                        02
                      </p>
                    </div>
                    <p className="mt-3 text-sm text-textblack text-center lg:text-base">
                      翻訳からドラフト・レビューまで、すべてをワンプラットフォームで完結できます
                    </p>
                  </div>
                  <figure>
                    <img
                      decoding="async"
                      src="/images/solution/img_contract_solution08.svg"
                      alt=""
                      className="w-auto h-full"
                    />
                  </figure>
                </div>
              </div>

              <div className="w-full lg:w-[280px]">
                <div className="flex flex-col-reverse items-center">
                  <div>
                    <div className="flex flex-col-reverse items-center">
                      <h3 className="text-xl font-bold text-textblack text-center lg:text-2xl font-feature-settings">
                        グローバル企業での導入実績
                      </h3>

                      <p className="text-4xl text-primary text-center font-robot font-bold lg:text-5xl">
                        03
                      </p>
                    </div>
                    <p className="mt-3 text-sm text-textblack text-center lg:text-base">
                      英文契約書を多く扱うグローバル企業でも導入されています
                    </p>
                  </div>
                  <figure>
                    <img
                      decoding="async"
                      src="/images/solution/img_contract_solution09.svg"
                      alt=""
                      className="w-auto h-full"
                    />
                  </figure>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  )
}
